<template lang="html">
  <div class="_modals">
    <b-modal ref="modalSubmit"
             centered
             hide-footer
             title="">
      <div>
        <p class="text-center">
          Do You Want to Submit this Payment?
        </p>
      </div>
      <div class="row mt-4">
        <div class="col-md text-center">
          <button
             @click="submitPayment()" class="button__bluecorporite ml-2">Yes
          </button>
          <button @click="closemodal()" class="button__redcorporite ml-2">No
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="modalAfterSubmit"
             centered
             hide-footer
             title="">
      <div>
        <p class="text-center">
          {{submitMessage}}
        </p>
      </div>
      <div class="text-center mt-4">
        <router-link  class="button__bluecorporite" to="/dashboard" tag="button" @click="closemodal()">
          Ok
        </router-link>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      submitMessage: '',
      form: {
        userEmail: '',
        intervalCount: '',
        totalAmount: ''
      }
    }
  },
  created () {
    this.$eventHub.$on('dialog-payment-alibaba', this.dialogSubmit)
  },
  beforeDestroy () {
    this.$eventHub.$off('dialog-payment-alibaba')
  },
  computed: {
    ...mapGetters({
      getPaymentResponse: 'alibabaPayment/postPayment',
      errorPostPayment: 'alibabaPayment/errorPostPayment',
      isLoadingPostPayment: 'alibabaPayment/isLoadingPostPayment'
    })
  },
  methods: {
    closemodal () {
      this.$refs.modalSubmit.hide()
      this.$refs.modalAfterSubmit.hide()
    },
    dialogSubmit (data) {
      this.form = data
      this.$refs.modalSubmit.show()
    },
    async submitPayment () {
      const payload = this.form
      await this.$store.dispatch('alibabaPayment/POST_PAYMENT_ALIBABA', payload).then(() => {
        if (this.getPaymentResponse && this.getPaymentResponse.data) {
          let url = this.getPaymentResponse.data.last_created_invoice_url || ''
          window.open(url, '_blank')
        } else if (this.errorPostPayment) {
          this.submitMessage = this.errorPostPayment.data.message || 'Error'
          this.$refs.modalAfterSubmit.show()
        }
        this.$refs.modalSubmit.hide()
        this.$router.push('/dashboard')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/AlibabaPayment.vue